<ng-container *ngIf="data !== undefined; else singleInputs">
  <div class="item-tag" [ngClass]="[data.color, (data.clickable) ? 'pointer-auto' : '', 'item-tag--size-' + data.size]" (click)="itemClicked.emit()">
    <span class="icon icon--before" *ngIf="data.beforeIcon" (click)="beforeIconClicked.emit()"><brt-icon [icon]="data.beforeIcon"></brt-icon></span>
    <span class="title" [innerHTML]="data.title"></span>
    <button role="button" class="icon icon--after" *ngIf="data.afterIcon" (click)="afterIconClicked.emit()"><brt-icon [icon]="data.afterIcon"></brt-icon></button>
  </div>
</ng-container>
<ng-template #singleInputs>
  <div class="item-tag" [ngClass]="[color, (clickable) ? 'pointer-auto' : '']" (click)="itemClicked.emit()">
    <span class="icon icon--before" *ngIf="beforeIcon" (click)="beforeIconClicked.emit()"><brt-icon [icon]="beforeIcon"></brt-icon></span>
    <span class="title" [innerHTML]="title"></span>
    <button role="button" class="icon icon--after" *ngIf="afterIcon" (click)="afterIconClicked.emit()"><brt-icon [icon]="afterIcon"></brt-icon></button>
  </div>
</ng-template>
